var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'main_wrap _ep _page_'+_vm.pageMode},[_c('episode-list',{on:{"select-list-item":_vm.viewItem}}),_c('episode-view',{ref:"epsodeView",on:{"close-view":_vm.viewList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }